import script from "./InvestForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestForm.vue?vue&type=script&setup=true&lang=ts"

import "./InvestForm.vue?vue&type=style&index=0&id=f6ec2da8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6ec2da8"]])

export default __exports__